import { WIDGET_HOME_TYPE_V2, WIDGET_TYPE_V2 } from '../common';
import { ValueOf } from '../../common/utils';
import { DateRageType } from '../../common/date';
import { EventItemV2 } from '../../event';
import { Attachment } from '../../../components/input/ImageAndVideoUploadV2/types';
import {
  EventWidgetsCreateRequestWidgetDto,
  EventWidgetsCreateRequestWidgetDtoLayoutTypeEnum,
  EventWidgetsCreateRequestWidgetItemEventDto,
  EventWidgetsFindOneResponseWidgetDto,
  WidgetResponseWidgetItemEventDto,
} from '../../api/widgets';

export const EVENT_WIDGET_LAYOUT_TYPE_V2 = {
  SWIPE: 'swipe',
} as const;

export type EVENT_WIDGET_LAYOUT_TYPE_V2 = ValueOf<typeof EVENT_WIDGET_LAYOUT_TYPE_V2>;

export const EVENT_WIDGET_ATTACHMENT_TYPE = {
  MOBILE: 'mobile',
  PC: 'pc',
} as const;
type EVENT_WIDGET_ATTACHMENT_TYPE = ValueOf<typeof EVENT_WIDGET_ATTACHMENT_TYPE>;

export type WidgetItemEvent = {
  id: number;
  no?: number;
  exposurePeriod: DateRageType;
  memo: string;
  event: EventItemV2;
  mobileImage: Required<Attachment>[];
  pcImage: Required<Attachment>[];
};

export class EventWidgetDetailV2 {
  type: typeof WIDGET_TYPE_V2.EVENT;
  layoutType: EVENT_WIDGET_LAYOUT_TYPE_V2;
  mainTitle: string;
  subTitle?: string;
  memo?: string;
  currentExposurePage?: string;
  widgetItemEvents: WidgetItemEvent[];

  private getImage(item: WidgetResponseWidgetItemEventDto, type: EVENT_WIDGET_ATTACHMENT_TYPE) {
    return [item.widgetItemEventAttachments.find((attachment) => attachment.type === type)!];
  }

  constructor(detail: EventWidgetsFindOneResponseWidgetDto) {
    this.type = detail.type;
    this.layoutType = detail.layoutType;
    this.mainTitle = detail.mainTitle;
    this.subTitle = detail.subTitle;
    this.memo = detail.memo;
    this.currentExposurePage = detail.home?.type === WIDGET_HOME_TYPE_V2.MAIN ? '메인 페이지' : detail.home?.title;
    this.widgetItemEvents = detail.widgetItemEvents
      .sort((a, b) => a.no - b.no)
      .map((item) => ({
        id: item.id,
        exposurePeriod: {
          startDate: item.exposureStartDate,
          endDate: item.exposureEndDate,
        },
        memo: item.memo,
        event: new EventItemV2(item.event),
        mobileImage: this.getImage(item, EVENT_WIDGET_ATTACHMENT_TYPE.MOBILE),
        pcImage: this.getImage(item, EVENT_WIDGET_ATTACHMENT_TYPE.PC),
      }));
  }
}

export class EventWidgetRequestPayloadV2 implements EventWidgetsCreateRequestWidgetDto {
  mainTitle: string;
  subTitle: string;
  memo: string;
  layoutType: EventWidgetsCreateRequestWidgetDtoLayoutTypeEnum;
  widgetItemEvents: Array<EventWidgetsCreateRequestWidgetItemEventDto>;
  constructor(detail: EventWidgetDetailV2) {
    this.mainTitle = detail.mainTitle;
    this.subTitle = detail.subTitle || '';
    this.memo = detail.memo || '';
    this.layoutType = detail.layoutType;
    this.widgetItemEvents = detail.widgetItemEvents.map((item) => ({
      eventId: item.event.id,
      exposureStartDate: item.exposurePeriod.startDate && new Date(item.exposurePeriod.startDate).toISOString(),
      exposureEndDate: item.exposurePeriod.endDate && new Date(item.exposurePeriod.endDate).toISOString(),
      memo: item.memo,
      widgetItemEventAttachments: [
        { ...item.mobileImage[0], type: EVENT_WIDGET_ATTACHMENT_TYPE.MOBILE },
        { ...item.pcImage[0], type: EVENT_WIDGET_ATTACHMENT_TYPE.PC },
      ],
    }));
  }
}
